export enum EPaymentActions {
    INIT_PAYMENT_STATE = 'PAYMENT/INIT_STATE',

    FILL_PAYMENT_SUM = 'PAYMENT/FORM/PAYMENT_SUM/FILL',
    SET_PAYMENT_SUM_VALIDATION = 'PAYMENT/FORM/PAYMENT_SUM/VALIDATE',
    FILL_EMAIL = 'PAYMENT/FORM/EMAIL/FILL',
    SELECT_EMAIL = 'PAYMENT/FORM/EMAIL/SELECT',
    SET_PHONE = 'PAYMENT/FORM/SET_PHONE',
    TOGGLE_PAY_WITH_BONUSES = 'PAYMENT/FORM/TOGGLE_PAY_WITH_BONUSES',
    FILL_BONUSES_VALUE = 'PAYMENT/FORM/BONUSES_VALUE/FILL',
    SET_BONUSES_VALUE_VALIDATION = 'PAYMENT/FORM/BONUSES_VALUE/VALIDATE',
    SET_CARD_SUM = 'PAYMENT/FORM/SET_CARD_SUM',

    SET_PAYMENT_TYPE_ID = 'SEASON_TICKET/SET_PAYMENT_TYPE_ID',
    SET_PAYMENT_METHOD = 'PAYMENT/SET_METHOD',
    TOGGLE_SAVE_CARD_STATUS = 'PAYMENT/TOGGLE_SAVE_CARD_STATUS',
    SET_PAYMENT_QR_LINK = 'PAYMENT/QR_LINK/SET',
    SET_PAYMENT_QR_CODE = 'PAYMENT/QR_CODE/SET',
    REMOVE_PAYMENT_QR_CODE = 'PAYMENT/QR_CODE/REMOVE',
    SET_PAYMENT_RESULT = 'PAYMENT/SET_RESULT',

    SET_TRANSACTIONS = 'PAYMENT/SET_TRANSACTIONS',
    SET_AGREEMENT = 'PAYMENT/SET_AGREEMENT',

    SET_ANALYTICS_DATA = 'PAYMENT/SET_ANALYTICS_DATA',
    SET_PAY_METHODS = 'PAYMENT/SET_PAY_METHODS',
    CLEAR_METHODS = 'PAYMENT/CLEAR_METHODS',

    TOGGLE_IS_SHOW_SPECOFFER = 'PAYMENT/TOGGLE_IS_SHOW_SPECOFFER',

    SET_CREDITS = 'SET_CREDITS',
    SET_CREDIT_LOADING = 'SET_CREDIT_LOADING',
    TOGGLE_CREDIT_SELECTION = 'TOGGLE_CREDIT_SELECTION',
}


export type { TClearPaymentMethods } from './clearPaymentMethods';
export { default as clearPaymentMethods } from './clearPaymentMethods';
export type { TFillBonusesValue } from './fillBonusesValue';
export { default as fillBonusesValue } from './fillBonusesValue';
export type { TFillEmail } from './fillEmail';
export { default as fillEmail } from './fillEmail';
export type { TFillPaymentSum } from './fillPaymentSum';
export { default as fillPaymentSum } from './fillPaymentSum';
export type { TInitPaymentState } from './initializePaymentState';
export { default as initializePaymentState } from './initializePaymentState';
export type { TRemovePaymentQrCode } from './removePaymentQrCode';
export { default as removePaymentQrCode } from './removePaymentQrCode';
export type { TSelectEmail } from './selectEmail';
export { default as selectEmail } from './selectEmail';
export type { TSetAgreement } from './setAgreement';
export { default as setAgreement } from './setAgreement';
export type { TSetAnalyticsData } from './setAnalyticsData';
export type { IAnalyticsData } from './setAnalyticsData';
export { default as setAnalyticsData } from './setAnalyticsData';
export type { TSetBonusesValueValidity } from './setBonusesValueValidity';
export { default as setBonusesValueValidity } from './setBonusesValueValidity';
export type { TSetCardPaymentSum } from './setCardPaymentSum';
export { default as setCardPaymentSum } from './setCardPaymentSum';
export type { TSetCreditLoading } from './setCreditLoading';
export { default as setCreditLoading } from './setCreditLoading';
export type { TSetCredits } from './setCredits';
export { default as setCredits } from './setCredits';
export type { TSetPaymentMethod } from './setPaymentMethod';
export { default as setPaymentMethod } from './setPaymentMethod';
export type { TSetPaymentMethods } from './setPaymentMethods';
export { default as setPaymentMethods } from './setPaymentMethods';
export type { TSetPaymentQrCode } from './setPaymentQrCode';
export { default as setPaymentQrCode } from './setPaymentQrCode';
export type { TSetPaymentQrLink } from './setPaymentQrLink';
export { default as setPaymentQrLink } from './setPaymentQrLink';
export type { TSetPaymentResult } from './setPaymentResult';
export type { IPaymentResult } from './setPaymentResult';
export { default as setPaymentResult } from './setPaymentResult';
export type { TSetPaymentSumValidity } from './setPaymentSumValidity';
export type { TPaymentSumValidity } from './setPaymentSumValidity';
export { EValidityStatus } from './setPaymentSumValidity';
export { default as setPaymentSumValidity } from './setPaymentSumValidity';
export type { TSetPaymentTypeId } from './setPaymentTypeId';
export { EPaymentTypeIds } from './setPaymentTypeId';
export { default as setPaymentTypeId } from './setPaymentTypeId';
export type { TSetPhone } from './setPhone';
export { default as setPhone } from './setPhone';
export type { TSetTransactions } from './setTransactions';
export type { TPaymentTransaction } from './setTransactions';
export { default as setTransactions } from './setTransactions';
export type { TToggleCreditSelection } from './toggleCreditSelection';
export { default as toggleCreditSelection } from './toggleCreditSelection';
export type { TToggleIsShowSpecOffer } from './toggleIsShowSpecOffer';
export { default as toggleIsShowSpecOffer } from './toggleIsShowSpecOffer';
export type { TTogglePayWithBonusesStatus } from './togglePayWithBonusesStatus';
export { default as togglePayWithBonusesStatus } from './togglePayWithBonusesStatus';
export type { TToggleSaveCardStatus } from './toggleSaveCardStatus';
export { default as toggleSaveCardStatus } from './toggleSaveCardStatus';
